module.exports = __webpack_public_path__ + "static/media/galerija_2016 (6).1e08dc8d.jpg";